module.exports = __webpack_public_path__ + "img/amountSD.7af92d90.svg";